import { SeoService } from "./../seoService";
import { BrowserModule, Title } from "@angular/platform-browser";
import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { HomeComponent } from "./pages/home.component";
import { SelectComponent } from "./pages/select/select.component";
import { LoginComponent } from "./pages/login/login.component";
import { ResetpassComponent } from "./pages/resetpass/resetpass.component";
import { SignupComponent } from "./pages/signup/signup.component";

import { AgencyComponent } from "./pages/signup/agencies/agencies.component";
import { HotelComponent } from "./pages/signup/hotels/hotels.component";
import { ProviderComponent } from "./pages/signup/providers/providers.component";
import { ChatComponent } from "./pages/signup/chat/chat.component";
import { ToolComponent } from "./pages/signup/tools/tools.component";
import { SelectAgencyModalComponent } from "./pages/select-agency-modal/select-agency-modal.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { HttpConfigInterceptor } from "./interceptor/http-config.interceptor";
import { LoginService } from "./pages/login/login.service";
import { AngularSvgIconModule } from "angular-svg-icon";
import { UsbCarouselModule } from "./shared/usb-carousel/usb-carousel.module";
import { NgxPaginationModule } from "ngx-pagination";
import { AboutUsComponent } from "./pages/shared/about-us/about-us.component";
import { HeroComponent } from "./pages/hero/hero.component";
import { SplashComponent } from "./pages/shared/splash/splash.component";
import { ShellModule } from "./pages/shell/shell.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { NotificationContainerComponent } from "./shared/notifications/notificationContainer/notificationContainer";
import { NotificationItemComponent } from "./shared/notifications/notificationItem/notificationItem";
import { NotificationService } from './shared/notifications/notification.service';
import { ChatFloatingComponent } from "./shared/helpdesk/chat-floating.component";
import { TurnstileComponent } from "./shared/turnstile/turnstile.component";
import { PartnersComponent } from './pages/partners/partners.component';
import { RevealOnScrollDirective } from './shared/directives/reveal-on-scroll.directive';
import { CountUpDirective } from './shared/directives/count-up.directive';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    ResetpassComponent,
    SignupComponent,
    AgencyComponent,
    HotelComponent,
    ProviderComponent,
    ChatComponent,
    ToolComponent,
    SelectComponent,
    SelectAgencyModalComponent,
    AboutUsComponent,
    HeroComponent,
    SplashComponent,
    NotificationContainerComponent,
    NotificationItemComponent,
    ChatFloatingComponent,
    TurnstileComponent,
    PartnersComponent,
    RevealOnScrollDirective,
    CountUpDirective
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ModalModule.forRoot(),
    AngularSvgIconModule.forRoot(),
    UsbCarouselModule,
    NgxPaginationModule,
    ShellModule,
    NgSelectModule,
  ],
  exports: [
  ],
  providers: [
    SeoService,
    Title,
    LoginService,
    NotificationService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
  }
}
